<div class="filter-cards">
  <div class="filter-card-container">
      <div *ngFor="let filter of filters">
        <button class="filter-card">
          <span (click)="removeFilter(filter)" class="filter-card-close-btn">x</span>
          <span>{{filter.propertyTranslation | translate}} : {{filter.valueTranslation | translate}}</span>
        </button>
      </div>
  </div>
  <div class="filter-buttons">
    <button (click)="resetFilter()" class="clear">{{'COMMON.CLEAR_ALL' | translate}}</button>
    <button *ngIf="useApply" (click)="applyFilter()" class="apply">{{'COMMON.APPLY' | translate}}</button>
  </div>
</div>